const routes = [
  {
    path: "/auth",
    name: "Auth",
    component: () =>
      import(/* webpackChunkName: "group-auth" */ "@/views/Auth.vue"),
    meta: {
      mode: "locked",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "group-auth" */ "@/views/Login.vue"),
    meta: {
      mode: "locked",
    },
  },
  {
    path: "/logout",
    name: "Logout",
    component: () =>
      import(/* webpackChunkName: "group-auth" */ "@/views/Logout.vue"),
    meta: {
      mode: "locked",
    },
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: () =>
      import(/* webpackChunkName: "group-auth" */ "@/views/Forbidden.vue"),
    meta: {
      mode: "dialog",
    },
  },
];

export default routes;
